/*
 * custom-events.js — Melagio
 * Opens Ira's flyout cart after our quick-add.
 */

document.addEventListener("flu:cart:item-added", function (evt) {
  // Try to open Ira's flyout using every known method
  try {
    // Method 1: Ira stores cart instance on window
    if (window.flu && window.flu.quickCart) {
      window.flu.quickCart.open();
    }

    // Method 2: Find and click Ira's cart trigger button
    const cartTrigger = document.querySelector('[data-cart-toggle], [data-quick-cart-toggle], .js-cart-toggle');
    if (cartTrigger) cartTrigger.click();

    // Method 3: Find cart drawer and open it directly
    const quickCart = document.querySelector('.quick-cart, [data-quick-cart], #quick-cart');
    if (quickCart) {
      quickCart.classList.add('is-open', 'active', 'open');
      quickCart.removeAttribute('hidden');
      quickCart.setAttribute('aria-hidden', 'false');
    }
  } catch(e) {
    console.warn('Could not open flyout:', e);
  }
});

document.addEventListener("flu:cart:updated", function (evt) {});
document.addEventListener("flu:cart:error",   function (evt) { console.log(evt.detail.errorMessage); });
document.addEventListener("flu:quick-cart:open",  function (evt) {});
document.addEventListener("flu:quick-cart:close", function () {});
document.addEventListener("flu:product:variant-change",  function (evt) {});
document.addEventListener("flu:product:quantity-update", function (evt) {});
document.addEventListener("quickview:loaded", function () {});